import React, { useState } from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { AgGridReact } from "ag-grid-react";
import { 
    Chart, 
    ChartLegend, 
    ChartTitle, 
    ChartCategoryAxis, 
    ChartCategoryAxisItem, 
    ChartValueAxis, 
    ChartValueAxisItem, 
    ChartSeries, 
    ChartSeriesItem,
    ChartTooltip
} from '@progress/kendo-react-charts';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import '@progress/kendo-theme-default/dist/all.css';

export const TopHoldingsTabs = () => {
    const [activeTab, setActiveTab] = useState("SPDR");
    const [timeRange, setTimeRange] = useState("1Y");
    const [Title, setTitle] = useState("SPDR S&P 500 ETF Trust Performance");

    const handleTabChange = (eventKey) => {
        setActiveTab(eventKey);
        if(eventKey==='SPDR')
        {
            setTitle('SPDR S&P 500 ETF Trust Performance')
        }
        if(eventKey==='MSCI')
        {
            setTitle('MSCI India ETF (India)')
        }
        if(eventKey==='Russell')
        {
            setTitle('Russell 2000 ETF (IWM)')
        }
        if(eventKey==='EFA')
        {
            setTitle('MSCI EAFE ETF (EFA)')
        }
        
    };

    const columnDefs = [
        { headerName: "Assets", field: "assets" },
        { headerName: "Share Price", field: "sharePrice", cellStyle: { textAlign: "right" }, headerClass: "text-end" },
        { headerName: "5-Day Change (%)", field: "fiveDayChange", cellStyle: { textAlign: "right" }, headerClass: "text-end" },
        { headerName: "YTD Change (%)", field: "ytdChange", cellStyle: { textAlign: "right" }, headerClass: "text-end" },
        { headerName: "MSCI Weight (%)", field: "msciWeight", cellStyle: { textAlign: "right" }, headerClass: "text-end" },
    ];

    const rowData = [
        { assets: "Microsoft Corporation", sharePrice: 435.25, fiveDayChange: -0.31, ytdChange: 15.75, msciWeight: 27.83 },
        { assets: "Apple Inc.", sharePrice: 255.27, fiveDayChange: 0.31, ytdChange: 32.59, msciWeight: 20.78 },
        { assets: "NVIDIA Corporation", sharePrice: 139.68, fiveDayChange: 3.68, ytdChange: 182.04, msciWeight: 17.37 },
        { assets: "Amazon.com, Inc.", sharePrice: 225.06, fiveDayChange: 0.06, ytdChange: 42.81, msciWeight: 8.27 },
        { assets: "Meta Platforms, Inc.", sharePrice: 599.85, fiveDayChange: 2.49, ytdChange: 68.48, msciWeight: 4.74 },
        { assets: "Alphabet Inc.", sharePrice: 194.61, fiveDayChange: 1.68, ytdChange: 39.33, msciWeight: 3.7 },
        { assets: "Eli Lilly and Company", sharePrice: 796.28, fiveDayChange: 3.71, ytdChange: 37.70, msciWeight: 3.48 },
        { assets: "Broadcom Inc.", sharePrice: 232.35, fiveDayChange: 5.24, ytdChange: 108.15, msciWeight: 2.72 }
    ];

    const performanceData = {
        MTD: [
            { month: 'Jan 1', value: 440 },
            { month: 'Jan 7', value: 445 },
            { month: 'Jan 14', value: 448 },
            { month: 'Jan 21', value: 447 },
            { month: 'Jan 28', value: 450 }
        ],
        QTD: [
            { month: 'Oct 24', value: 425 },
            { month: 'Nov 24', value: 435 },
            { month: 'Dec 24', value: 442 },
            { month: 'Jan 25', value: 450 }
        ],
        YTD: [
            { month: 'Jan 1', value: 440 },
            { month: 'Jan 7', value: 445 },
            { month: 'Jan 14', value: 448 },
            { month: 'Jan 21', value: 447 },
            { month: 'Jan 28', value: 450 }
        ],
        "1Y": [
            { month: 'May 24', value: 380 },
            { month: 'Jun 24', value: 390 },
            { month: 'Jul 24', value: 400 },
            { month: 'Aug 24', value: 410 },
            { month: 'Sep 24', value: 420 },
            { month: 'Oct 24', value: 435 },
            { month: 'Nov 24', value: 440 },
            { month: 'Dec 24', value: 445 },
            { month: 'Jan 25', value: 450 }
        ],
        "3Y": [
            { month: 'Jan 22', value: 280 },
            { month: 'Jul 22', value: 320 },
            { month: 'Jan 23', value: 350 },
            { month: 'Jul 23', value: 390 },
            { month: 'Jan 24', value: 420 },
            { month: 'Jan 25', value: 450 }
        ],
        "5Y": [
            { month: 'Jan 20', value: 200 },
            { month: 'Jan 21', value: 260 },
            { month: 'Jan 22', value: 320 },
            { month: 'Jan 23', value: 380 },
            { month: 'Jan 24', value: 420 },
            { month: 'Jan 25', value: 450 }
        ]
    };

    const defaultColDef = {
        flex: 1,
        minWidth: 150,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        editable: false,
        resizable:true
    };
    const PerformanceChart = ({ data, timeRange, onTimeRangeChange}) => {
        const timeRanges = ["MTD", "QTD", "YTD", "1Y", "3Y", "5Y"];
    
        return (
            <div>
                {/* Box Container for Time Range Tabs */}
                <div className="d-flex justify-content-end"> 
                    <div className="button-container">
                        {timeRanges.map((range) => (
                            <button
                                key={range}
                                className={`p-2 ${timeRange === range ? "selected-non-gappable-button" : "non-gappable-button"}`}
                                onClick={() => onTimeRangeChange(range)}
                            >
                                {range}
                            </button>
                        ))}
                    </div>
                </div>
    
                {/* Chart */}
                <Chart style={{ height: 350, width: 'auto' }}>
                    <ChartTitle text={Title}/>
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                            categories={data.map((item) => item.month)}
                            labels={{ rotation: -45 }}
                        />
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                        <ChartValueAxisItem
                            labels={{ format: "${0}" }}
                            min={Math.min(...data.map((item) => item.value)) - 20}
                            max={Math.max(...data.map((item) => item.value)) + 20}
                            majorGridLines={{ visible: true, color: "#e5e5e5" }}
                        />
                    </ChartValueAxis>
                    <ChartTooltip format="${0}" />
                    <ChartSeries>
                        <ChartSeriesItem
                            type="area"
                            data={data.map((item) => item.value)}
                            color="#53c685"
                            opacity={0.6}
                            line={{
                                style: "smooth",
                                width: 2,
                                color: "#1a5235",
                            }}
                            markers={{
                                visible: true,
                                size: 6,
                                background: "#2e8b57",
                            }}
                            gradient={{
                                opacity: 0.5,
                                stops: [
                                    { offset: 0, color: "#2e8b57", opacity: 0.7 },
                                    { offset: 0.5, color: "#2e8b57", opacity: 0.5 },
                                    { offset: 1, color: "#2e8b57", opacity: 0.3 },
                                ],
                            }}
                        />
                    </ChartSeries>
                </Chart>
            </div>
        );
    };
    
    // Pie chart UI starts
    const MSCIWeightChart = ({ data }) => {
        const pieData = data.map(item => ({
            category: item.assets,
            value: item.msciWeight
        }));
    
        const othersValue = 11.11;
        pieData.push({ category: "Others", value: othersValue });
    
        return (
            <div>
                <Chart>
                    <ChartTitle text = {Title} />
                    <ChartLegend position="right" />
                    <ChartSeries>
                        <ChartSeriesItem
                            type="donut"
                            data={pieData}
                            categoryField="category"
                            field="value"
                            holeSize={45}
                            labels={{
                                visible: true,
                                content: (e) => `${e.value}%`,
                                position: "outsideEnd"
                            }}
                        />
                    </ChartSeries>
                    <ChartTooltip />
                </Chart>
            </div>
        );
    };
    
    return (
        <div className="container mt-5">
            <Tabs
                activeKey={activeTab}
                id="holdings-tab-example"
                className="mb-3"
                onSelect={handleTabChange}
            >
                <Tab eventKey="SPDR" title="SPDR S&P 500 ETF Trust">
                    <div>
                        <h5 style={{ color: "#037196" }}>Top 10 Holdings out of 500</h5>
                        <div
                            className="ag-theme-alpine"
                            style={{ height: "50vh", width: "100%" }}
                        >
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                            />
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="MSCI" title="MSCI India ETF (India)">
                    <div>
                        <h5 style={{ color: "#037196" }}>Top 10 Holdings out of 500</h5>
                        <div
                            className="ag-theme-alpine"
                            style={{ height: "50vh", width: "100%" }}
                        >
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                            />
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="Russell" title="Russell 2000 ETF (IWM)">
                    <div>
                        <h5 style={{ color: "#037196" }}>Top 10 Holdings out of 500</h5>
                        <div
                            className="ag-theme-alpine"
                            style={{ height: "50vh", width: "100%" }}
                        >
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                            />
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="EFA" title="MSCI EAFE ETF (EFA)">
                    <div>
                        <h5 style={{ color: "#037196" }}>Top 10 Holdings out of 500</h5>
                        <div
                            className="ag-theme-alpine"
                            style={{ height: "50vh", width: "100%" }}
                        >
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                            />
                        </div>
                    </div>
                </Tab>
            </Tabs>

            {/* Place these chart components outside of individual tabs so they show up on all tabs */}
            <div className="d-flex mt-4">
                <div className="detail w-50 p-2">
                    <PerformanceChart 
                        data={performanceData[timeRange]} 
                        timeRange={timeRange}
                        onTimeRangeChange={setTimeRange}
                    />
                </div>
                <div className="detail w-50 p-2">
                    <MSCIWeightChart data={rowData} />
                </div>
            </div>
        </div>
    );
};

// Performance chart UI changes

// Pie chart UI ends

export default TopHoldingsTabs;
